import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { Global } from './core/Global';


@Injectable()

export class BankService {
	public url: string;
	public identity: any;
	public token: any;
	public entidad: any;

	constructor(
		private _http: HttpClient,
	) {
		this.url = Global.url_seguros;

	}
	getAll(): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		//Hacer peticion ajax
		var resultado = this._http.get(this.url + 'banks', {headers: headers})
		return resultado;

	}
	save(bank: any): Observable<any> {
		let params = bank;
		//definir las cabeceras
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		//Hacer peticion ajax
		var resultado = this._http.post(this.url + 'banks', params, {headers: headers})
		return resultado;
	}
	update(bank: any): Observable<any> {
		let params = bank
		let headers = new HttpHeaders().set('Content-Type','application/json')

		var resultado = this._http.patch(this.url + 'banks/' + params._id, params, {headers: headers})
		return resultado;
	}

	getTypeAccount(): Observable<any> {

		//entidad.campo = this.identity.campo;
		let params = {};
		//definir las cabeceras
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		//Hacer peticion ajax
		var resultado = this._http.get(this.url + 'banks/types', {headers: headers})
		return resultado;

	}




}
